import web from "../web";

class CivilitesService {
    index(token){
        return web.get("/api/civilites", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/civilites", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/civilites/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/civilites/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/civilites/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new CivilitesService()